import React, { useState,useEffect } from 'react';
import axios from 'axios'
import CommonVars from '../Component/CommonVars';
import {
    Flex,
    Box,
    Image,
    Heading,
    VStack,
    Button,
    Link
  } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

function OrderDetailsScreen () {
    const [orderDetails, setOrderDetails] = useState([]);
    const orderid = useParams().orderid
    const userid = useParams().userid
    useEffect(() => {
        getOrderDetails();
    }, [])

    const getOrderDetails = async() => {
        axios.get(`${CommonVars.API_URL}/orders/${orderid}/user/${userid}/`)
        .then((res) =>{
            const OrderDetail = res.data[0]
            console.log(OrderDetail)
            setOrderDetails(OrderDetail)
        })

    }

    const aOrderDetail = []

    aOrderDetail.push(
        <Box marginInline={'400'} marginY={'190'} w={'800px'}  shadow={'lg'}  roundedTop={'lg'} bg={'gray.100'}>
            <Flex>
                <Image boxSize={'300'} src={orderDetails.image}/>
                <VStack marginInlineStart={'100'}>
                    <Box margin={'5'}  fontSize={'2xl'} fontWeight={'bold'}>
                        {orderDetails.username}
                    </Box>
                    <Box margin={'5'}  fontSize={'2xl'} fontWeight={'bold'}>
                        {orderDetails.name}
                    </Box>
                    <Box margin={'3'}  fontSize={'lg'} fontWeight={'semibold'}>
                    Total: {orderDetails.total}
                    </Box>

                </VStack>
                

            </Flex>
            
        </Box>
    )

    return (
        <Box>
            <Heading>Order Details</Heading>
            <Box>
                {aOrderDetail}
            </Box>
        </Box>
    )
}

export default OrderDetailsScreen;